<template>
  <div id="contenedor-auditorias-main">
    <v-container fluid>
      <v-card flat class="mb-4 rounded-lg">
        <v-card-text class="px-0 py-1">
          <TituloToolBar titulo="Auditorías">
            <template v-slot:opciones-derecha>
              <v-btn
                v-show="true"
                text
                rounded
                class="text-capitalize"
                :to="{ name: 'auditoriasTablero' }">
                <v-icon left color="primary">
                  mdi-chart-gantt
                </v-icon>
                Tablero
              </v-btn>
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    icon>
                    <v-icon>
                      mdi-cog-outline
                    </v-icon>
                  </v-btn>
                </template>
                <v-list dense nav>
                  <v-list-item
                  @click="mostrarAgregarEnteFiscalizador = !mostrarAgregarEnteFiscalizador">
                  <v-list-item-icon class="mr-2">
                    <v-icon>
                      mdi-account-group
                    </v-icon>
                  </v-list-item-icon>
                    <v-list-item-title>
                      Entes Fiscalizadores
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
            </v-menu>
            </template>
          </TituloToolBar>
          <ToolBarTab :filtros="filtros" />
        </v-card-text>
      </v-card>
      <v-card flat>
        <v-card-text>
          <Listado
            :filtros="filtros">
          </Listado>
        </v-card-text>
      </v-card>
    </v-container>
    <v-dialog
      v-model="mostrarAgregarEnteFiscalizador"
      width="600"
      persistent>
      <v-card>
        <v-card-text>
          <MainEntesFiscalizadores
            v-on:cerrar="mostrarAgregarEnteFiscalizador=!mostrarAgregarEnteFiscalizador">
          </MainEntesFiscalizadores>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import TituloToolBar from '@/components/TituloToolBar.vue';
import MainEntesFiscalizadores from '@/components/administracion/configuracion/catalogos/entesfiscalizadores/listado.vue';
import ToolBarTab from './ToolBarTab.vue';
import Listado from './listado/Main.vue';

export default {
  name: 'AuditoriasDefault',
  components: {
    ToolBarTab,
    TituloToolBar,
    MainEntesFiscalizadores,
    Listado,
  },
  data() {
    return {
      mostrarAgregarEnteFiscalizador: false,
      filtros: {
        ejercicio: new Date().getFullYear(),
        buscarTexto: '',
        enteFiscalizador: '',
      },
    };
  },
  mounted() {
    const getFiltros = window.localStorage.getItem('filtros-auditorias');

    if (getFiltros) {
      const parseFiltros = JSON.parse(getFiltros);
      this.filtros = parseFiltros;
      if (typeof parseFiltros.ejercicio === 'string') {
        const split = parseFiltros.ejercicio.split('-');
        this.filtros.ejercicio = Number(split[0]);
      } else {
        this.filtros.ejercicio = Number(parseFiltros.ejercicio);
      }
    }
  },
  watch: {
    filtros: {
      handler(filtros) {
        const filtrosString = JSON.stringify(filtros);
        window.localStorage.setItem('filtros-auditorias', filtrosString);
      },
      deep: true,
    },
  },
};
</script>
